

import Vue from 'vue'
import App from './App'
import router from './router'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'


Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)
Vue.config.productionTip = false
localStorage.setItem('isAndroid', navigator.userAgent.indexOf('Android') > -1);
/* eslint-disable no-new */
new Vue({
el: '#app',
router,
components: { App },
template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js